const config = {
    API_URL: 'https://signaltuner-back.azurewebsites.net/'
    // API_URL: 'https://localhost:7090/'
  };
  
  export default config;